// Shared label for Modern Trade product pickers: "<barcode> – <name>".
// When the product has no barcode, the SKU stands in ("<sku> – <name>") and
// noBarcode is true so the picker can show a small "No barcode" tag
// (i18n: modern_trade.common.no_barcode).
//
// Accepts both wms-product-options rows ({barcode, man_pn, name}) and
// bo_mt_product rows ({barcode, code, name}) as well as wms_* prefixed joins.
export function mtProductLabel(p) {
  const row = p || {};
  const barcode = row.barcode || row.wms_barcode || "";
  const sku = row.man_pn || row.sku_code || row.code || "";
  const name = row.name || row.wms_name || "";
  const key = barcode || sku;
  return {
    text: key && name ? `${key} – ${name}` : key || name,
    noBarcode: !barcode,
  };
}
